import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import CrmPrivateRoute from '../components/CRM/PrivateRoute';
import LoadingBar from '../components/LoadingBar';
import PortalPrivateRoute from '../components/PrivateRoute';

const HomeScreen = lazy(() => import('../screens/Home'));
const ProfileScreen = lazy(() => import('../screens/Profile'));
const InboxScreen = lazy(() => import('../screens/Inbox'));
const VentureScreen = lazy(() => import('../screens/Venture'));
const ContactScreen = lazy(() => import('../screens/Contact'));
const ReserveScreen = lazy(() => import('../screens/Reserve'));
const SimulationScreen = lazy(() => import('../screens/Simulation'));
const LoginScreen = lazy(() => import('../screens/Login'));
const RegisterScreen = lazy(() => import('../screens/Register'));
const PasswordRecoveryScreen = lazy(() => import('../screens/PasswordRecovery'));
const AdminLoginForm = lazy(() => import('../screens/CRM/Login'));
const ChangePassword = lazy(() => import('../screens/CRM/ChangePassword'));
const Dashboard = lazy(() => import('../screens/CRM/Dashboard'));
const LoggedScreen = lazy(() => import('../screens/Logged'));
const ContractDetailScreen = lazy(() => import('../screens/ContractDetail'));
const ContractsScreen = lazy(() => import('../screens/Contract'));
const NewPasswordScreen = lazy(() => import('../screens/NewPassword'));
const NotFoundScreen = lazy(() => import('../screens/NotFound'));
const PrivacyPolicyScreen = lazy(() => import('../screens/PrivacyPolicy'));
//const Admin = lazy(() => import('../screens/CRM/Articles/Admin'));
const ArticlePageForm = lazy(() => import('../screens/CRM/Article'));
const ArticlesPaginatedGrid = lazy(() => import('../screens/CRM/ArticlesPaginatedGrid'));
const UsersCrmPaginatedGrid = lazy(() => import('../screens/CRM/UsersPaginatedGrid'));
const GalleryPaginatedGrid = lazy(() => import('../screens/CRM/GalleryPaginatedGrid'));

const RoutersApp = () => {
  return (
    <Suspense fallback={<LoadingBar />}>
      <Routes>
        <Route index element={<HomeScreen />} />
        <Route path='login' element={<LoginScreen />} />
        <Route path='empreendimentos/:id' element={<VentureScreen />} />
        <Route path='/empreendimentos/:id/lotes/:idBatch/contatar' element={<ContactScreen />} />
        <Route path='/empreendimentos/:id/lotes/:idBatch/reservar' element={<ReserveScreen />} />
        <Route path='/empreendimentos/:id/lotes/:idBatch/simular' element={<SimulationScreen />} />
        <Route path='cadastro' element={<RegisterScreen />} />
        <Route path='esqueci-minha-senha' element={<PasswordRecoveryScreen />} />
        <Route path='nova-senha' element={<NewPasswordScreen />} />
        <Route path='/admin' element={<AdminLoginForm />} />
        <Route path='/admin/login' element={<AdminLoginForm />} />
        <Route path='/admin/change-password' element={<ChangePassword />} />
        <Route path='/politicas-de-privacidade' element={<PrivacyPolicyScreen />} />
        <Route element={<CrmPrivateRoute />}>
          <Route path='/admin/dashboard' element={<Dashboard title='Dashboard' />} />
          <Route
            path='/admin/configurations'
            element={<ArticlePageForm category='configurations' title='Configurações do portal' />}
          />
          <Route path='/admin/users' element={<UsersCrmPaginatedGrid title='Usuários' />} />
          <Route
            path='/admin/articles/about'
            element={<ArticlePageForm category='about' title='Sobre' />}
          />
          <Route
            path='/admin/articles/ventures'
            element={<ArticlesPaginatedGrid category='venture' title='Empreendimentos' />}
          />
          <Route
            path='/admin/articles/galleries'
            element={<GalleryPaginatedGrid title='Galeria de fotos' />}
          />
        </Route>
        <Route element={<PortalPrivateRoute />}>
          <Route path='/inicio' element={<LoggedScreen />} />
          <Route path='/perfil' element={<ProfileScreen />} />
          <Route path='/caixa-de-entrada' element={<InboxScreen />} />
          <Route path='/contratos' element={<ContractsScreen />} />
          <Route path='/contratos/:idContrato/detalhes' element={<ContractDetailScreen />} />
        </Route>
        <Route path='*' element={<NotFoundScreen />} />
      </Routes>
    </Suspense>
  );
};

export default RoutersApp;
